// Post-SSO landing page. Azure redirects to /auth/callback on the backend, which
// redirects here with the JWT in the URL fragment.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setToken } from "@/lib/auth-token";
import { api } from "@/lib/api";
import { useAuthStore } from "@/stores/auth-store";

export default function AuthCompletePage() {
  const navigate = useNavigate();
  const setMe = useAuthStore((s) => s.setMe);

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const token = params.get("token");
    if (!token) { navigate("/login?error=missing_token"); return; }
    setToken(token);
    api.get("/auth/me").then((r) => {
      setMe(r.data);
      navigate("/");
    }).catch(() => navigate("/login?error=me_failed"));
  }, [navigate, setMe]);

  return <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">Signing you in…</div>;
}
